import { useRef } from 'react';

export type TScrollDirection = 'scrollTop' | 'scrollLeft' | 'scroll';

type UseScrollReturn<T> = {
  eleRef: React.RefObject<T | undefined>;
  scroll: () => void;
};

 

// 实现函数
export function useScroll<T extends HTMLElement>({
  classname,
  scrollDirection,
  value,
}: {
  classname?: string;
  scrollDirection: TScrollDirection;
  value: ScrollToOptions | (() => ScrollToOptions) | number | (() => number);
}): UseScrollReturn<T> {
  const eleRef = useRef<T>();
  function scroll() {
    if (eleRef.current) {
      let scrollBox = eleRef.current;
      if (classname) {
        scrollBox = eleRef.current.querySelector(classname) as T;
      }

      if (scrollBox) {
        const data = typeof value === 'function' ? value() : value;

        if (scrollDirection === 'scroll') {
          scrollBox.scrollTo(data as ScrollToOptions);
        } else {
          scrollBox[scrollDirection] = data as number;
        }
      }
    }
  }

  return { eleRef, scroll };
}
